/**
 * Resolve the URL prefix for nav links that belong to a given host.
 *
 * The empty string means "same origin": the caller renders path-relative links
 * that resolve against whatever host the app is running on (localhost, staging,
 * production), which is how an app links to its OWN pages without any
 * per-environment configuration. A non-empty domain pins links to that host —
 * how an app links to its PEER (the customer portal linking to www), where
 * same-origin would resolve to the wrong site.
 *
 * Internal to the nav components; not exported from the package barrel.
 */
export function hostBase(domain: string): string {
  return domain ? `https://${domain}` : '';
}
